// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkRequest_wrapper__XC0fE"};